import React from 'react';
import PropTypes from 'prop-types';
import Button from 'wonderbly-components/lib/Button';
import './PaidForButton.scss';

const PaidForButton = props => {
  return (
    <Button
      className="button--paid-for"
      colour="green"
      onClick={props.handleOnClick}
      disabled={props.disabled}
      raised
      fullWidth>
      {props.cta}
    </Button>
  );
};

PaidForButton.propTypes = {
  total: PropTypes.string.isRequired,
  cta: PropTypes.string,
  disabled: PropTypes.bool,
  handleOnClick: PropTypes.func.isRequired,
  submittingMethod: PropTypes.string,
};

export default PaidForButton;



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/PaidForButton/PaidForButton.js